import React from 'react'
import Header from './header'
import Content from './content'
import Footer from './footer'

import '../../assets/stylesheets/homepage.css'

class HomePage extends React.Component {
  constructor(props) {
    super(props)

    this.VIEWS = {
      form: 'form',
      thanks: 'thanks'
    }

    this.state = {
      formError: true,
      formEnabled: true,
      formChanged: false,
      requireConsent: true,
      consentError: false,
      view: this.VIEWS.form
    }

    this.analytics = window.amplitude.getInstance()

    this.formRefs = {}
    this.formError = this.formError.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleFormChange = this.handleFormChange.bind(this)
  }

  componentWillMount() {
    this.formRefs = {}
  }

  componentDidMount() {
    this.analytics.logEvent('[Home Page] View')
    this.setState({requireConsent: this.props.continent === 'EU'})
  }

  formError(state) {
    this.setState({formError: state, formEnabled: !state})
  }

  handleFormChange() {
    if( !this.state.formChanged ) {
      this.analytics.logEvent('[Home Page] Change Registration Form')
      this.setState({formChanged: true})
    }
  }

  async handleSubmit(e) {
    e.preventDefault()

    // For EU visitors make sure consent was checked off
    if( this.state.requireConsent ) {
      if( !this.formRefs.consent.checked ) {
        this.setState({ formError: true, consentError: true })
        return
      }
    }

    this.setState({formEnabled: false})

    const formValues = {
      email: this.formRefs.email.value,
      url: this.formRefs.url.value,
      name: this.formRefs.name.value,
      phone: this.formRefs.phone.value,
      budget: this.formRefs.budget.value
    }

    try {
      await this.submitForm(formValues)
      this.analytics.logEvent('[Home Page] Complete Registration Form', formValues)
      this.analytics.setUserProperties(formValues)
      this.analytics.setUserId(this.formRefs.email.value)

      // On success, flip to thank you
      this.setState({
        view: this.VIEWS.thanks
      })
    } catch(e) {
      console.log('Something went wrong')
    }
  }

  submitForm(payload) {
    return new Promise((resolve, reject) => {
      fetch('https://encore.quicksprout.com/users/registration', {
        method: 'post',
        body: JSON.stringify(payload),
        headers: new Headers({
          'accept': 'application/json',
          'content-type': 'application/json'
        }),
        credentials: 'include',
        mode: 'cors'
      }).then(r => resolve(r))
        .catch(e => reject(e))
    })
  }

  render() {
    return (
      <div className="wrapper">
        <Header />
        <Content
          requireConsent={this.state.requireConsent}
          consentError={this.state.consentError}
          currentView={this.state.view}
          viewOptions={this.VIEWS}
          formEnabled={this.state.formEnabled}
          formError={this.formError}
          formRefs={this.formRefs}
          handleFormChange={this.handleFormChange}
          handleSubmit={this.handleSubmit} />
        <Footer />
      </div>
    )
  }
}

export default HomePage



// WEBPACK FOOTER //
// ./src/components/homepage/index.js